module.exports = __webpack_public_path__ + "img/CellCycle-GBM_GSE194329.e3589e0e.png";